import type { Bookmark } from "api/schemas/bookmarksApiSchemas";
import { InfinityLoader } from "common/components";
import { BookmarkItem } from "domains/bookmarks/components/BookmarkItem";

type BookmarkListProps = {
  hasNextPage: boolean;
  isPending: boolean;
  items: Bookmark[];
  loadNextPage: () => void;
  selectedId?: string;
};

export const BookmarkList = ({ items, hasNextPage, isPending, selectedId, loadNextPage }: BookmarkListProps) => (
  <InfinityLoader isPending={isPending} hasNextPage={hasNextPage} loadNextPage={loadNextPage}>
    {items.map((item) => (
      <BookmarkItem key={item.id} isSelected={selectedId === item.id} bookmark={item} />
    ))}
  </InfinityLoader>
);
